const ApplicationName = 'Order Tracker';

const Links = Object.freeze({
    orderTrackerTile: {
        hovered: 'Order Tracker Tile Hovered',
        viewFAQLink: 'Order Tracker Tile View FAQS clicked',
        ordersSummaryPage: 'Orders Summary Page visited from Order Tracker Tile',
    },
    ordersFilter: {
        open: 'Filter opened',
        cancel: 'Filter Cancel',
        apply: 'Filter Apply',
        allFilters: 'All Filters',
        allActions: 'All Actions',
        clearAll: 'Filter Clear All',
        selectedForFilter: 'Filter selected', // items selected for filter
    },
    orderExpress: {
        tileLink: 'Order Tracker Tile Order Express clicked',
        summaryLink: 'Order Express clicked',
        summaryNoResultLink: 'No search result Order Express clicked',
        popupContinue: 'Order Express continue button clicked',
        popupCancel: 'Order Express cancel button clicked',
    },
    search: 'Searched for Orders',
    ordersTabSelection: 'Order summary tab clicked',
    locationsTabSelection: 'Location summary tab clicked',
    Orders: {
        orderEnquiry: 'Order enquiry clicked',
        orderDetailsPage: 'Orders Details Page visited from Order summary Page',
        searchInput: 'Order Details search option',
        filterSelection: 'Order summary-Filter applied',
        showMore: '',
        showLess: '',
        locationTitle: '',
        pageSizeChange: 'Order summary-Page Size changed',
        pageChange: 'Order summary-Page Number changed',
        columnSelection: {
            open: 'Order summary-Select columns opened',
            apply: 'Order summary-Select columns Apply',
            cancel: 'Order summary-Select columns Cancel',
            reset: 'Order summary-Select columns Reset',
            columns: {
                number: 'Order summary-Select columns Order number',
                ncp: 'Order summary-Select columns Secondary reference',
                status: 'Order summary-Select columns Order status',
                estimatedDelivery: 'Order summary-Select columns Order estimated',
                requiredDelivery: 'Order summary-Select columns Order required',
                location: 'Order summary-Select columns Location',
                sitesComplete: 'Order summary-Select columns Sites completed',
                closedDate: 'Order summary-Select columns Order completed',
                customerName: 'Order summary-Select columns Customer',
                cidn: 'Order summary-Select columns Customer ID',
                yourReference: 'Order summary-Select columns Your reference',
                projectManager: 'Order summary-Select columns Project manager'
            }
        },
        referenceUpdate: 'Order reference add / update',
        downloadOrders: {
            open: 'Order summary-Download summary opened',
            options: {
                'csv': 'Order summary-Download summary All orders (CSV) selected',
                'pdf': 'Order summary-Download summary All orders (PDF) selected',
                'Advanced option': 'Order summary-Download summary Advanced options selected'
            },
            advanceOptions: {
                'All columns':
                    'Order summary-Advanced download summary All columns selected',
                'The columns I have selected':
                    `Order summary-Advanced download summary The columns selected`,
                'CSV': 'Order summary-Advanced download summary CSV selected',
                'PDF': 'Order summary-Advanced download summary PDF selected',
                'My search and filtered results only':
                    'Order summary-Advanced download summary Search and filters',
                'closed': 'Order summary-Advanced download summary Cancel clicked',
                'download': 'Order summary-Advanced download summary Download clicked',
            }
        },
        sorting: {
            'number:asc': 'Order summary-Order number Ascending Sorting',
            'number:desc': 'Order summary-Order number Descending Sorting',
            'ncp:asc': 'Order summary-Secondary reference Ascending Sorting',
            'ncp:desc': 'Order summary-Secondary reference Descending Sorting',
            'status:asc': 'Order summary-Order status Ascending Sorting',
            'status:desc': 'Order summary-Order status Descending Sorting',
            'status:default': 'Order summary-Order status Default Sorting',
            'estimatedDelivery:asc': 'Order summary-Order estimated Ascending Sorting',
            'estimatedDelivery:desc': 'Order summary-Order estimated Descending Sorting',
            'requiredDelivery:asc': 'Order summary-Order required Ascending Sorting',
            'requiredDelivery:desc': 'Order summary-Order required Descending Sorting',
            'location:asc': 'Order summary-Location Ascending Sorting',
            'location:desc': 'Order summary-Location Descending Sorting',
            'sitesComplete:asc': 'Order summary-Sites completed Ascending Sorting',
            'sitesComplete:desc': 'Order summary-Sites completed Descending Sorting',
            'closedDate:asc': 'Order summary-Order completed Ascending Sorting',
            'closedDate:desc': 'Order summary-Order completed Descending Sorting',
            'customerName:asc': 'Order summary-Customer Ascending Sorting',
            'customerName:desc': 'Order summary-Customer Descending Sorting',
            'cidn:asc': 'Order summary-Customer ID Ascending Sorting',
            'cidn:desc': 'Order summary-Customer ID Descending Sorting',
            'yourReference:asc': 'Order summary-Your reference Ascending Sorting',
            'yourReference:desc': 'Order summary-Your reference Descending Sorting',
            'projectManager:asc': 'Order summary-Project manager Ascending Sorting',
            'projectManager:desc': 'Order summary-Project manager Descending Sorting',
            '': 'Order summary-Default Sorting',
            'undefined': 'Order summary-Default Sorting'
        }
    },
    Locations: {
        orderEnquiry: 'Location summary-Order enquiry clicked',
        orderDetailsPage: 'Location summary-Orders Details Page visited from Location summary',
        showMore: 'Location summary-Show More clicked',
        showLess: 'Location summary-Show Less clicked',
        locationTitle: 'Location summary-Location Title clicked',
        pageSizeChange: 'Location summary-Page Size changed',
        pageChange: 'Location summary-Page Number changed',
        tableHeaderAccordianClicked: 'Location summary-Table Header Accordion clicked',
        columnSelection: {
            open: 'Location summary-Select columns opened',
            apply: 'Location summary-Select columns Apply',
            cancel: 'Location summary-Select columns Cancel',
            reset: 'Location summary-Select columns Reset',
            columns: {
                name: 'Location summary-Select columns Product',
                serviceId: 'Location summary-Select columns Service ID',
                productType: 'Location summary-Select columns Product type',
                productStatus: 'Location summary-Select columns Product status',
                siteAddress: 'Location summary-Select columns Site address',
                siteName: 'Location summary-Select columns Site name',
                productEstimatedDelivery: 'Location summary-Select columns Product estimated',
                productRequiredDelivery: 'Location summary-Select columns Product required',
                productClosedDate: 'Location summary-Select columns Product completed',
                billing: 'Location summary-Select columns Billing',
                number: 'Location summary-Select columns Order number',
                ncp: 'Location summary-Select columns Secondary reference',
                customerName: 'Location summary-Select columns Customer',
                cidn: 'Location summary-Select columns Customer ID',
                yourReference: 'Location summary-Select columns Your reference',
                projectManager: 'Location summary-Select columns Project manager'
            }
        },
        downloadOrders: {
            open: 'Location summary-Download summary opened',
            options: {
                'csv': 'Location summary-Download summary All locations and products(CSV)',
                'pdf': 'Location summary-Download summary All locations and products(PDF)',
                'Advanced option': 'Location summary-Download summary Advanced options selected'
            },
            advanceOptions: {
                'All columns':
                    'Location summary-Advanced download summary All columns selected',
                'The columns I have selected':
                    `Location summary-Advanced download summary The columns selected`,
                'CSV': 'Location summary-Advanced download summary CSV selected',
                'PDF': 'Location summary-Advanced download summary PDF selected',
                'My search and filtered results only':
                    'Location summary-Advanced download summary Search and Filters',
                'closed': 'Location summary-Advanced download summary Cancel clicked',
                'download': 'Location summary-Advanced download summary Download clicked',
            }
        },
        sorting: {
            'name:asc': 'Location summary-Product Ascending Sorting',
            'name:desc': 'Location summary-Product Descending Sorting',
            'serviceId:asc': 'Location summary-Service ID Ascending Sorting',
            'serviceId:desc': 'Location summary-Service ID Descending Sorting',
            'productType:asc': 'Location summary-Product type Ascending Sorting',
            'productType:desc': 'Location summary-Product type Descending Sorting',
            'productStatus:asc': 'Location summary-Product status Ascending Sorting',
            'productStatus:desc': 'Location summary-Product status Descending Sorting',
            'productStatus:default': 'Location summary-Product status Default Sorting',
            'siteAddress:asc': 'Location summary-Site address Ascending Sorting',
            'siteAddress:desc': 'Location summary-Site address Descending Sorting',
            'siteName:asc': 'Location summary-Site name Ascending Sorting',
            'siteName:desc': 'Location summary-Site name Descending Sorting',
            'productEstimatedDelivery:asc':
                'Location summary-Product estimated Ascending Sorting',
            'productEstimatedDelivery:desc':
                'Location summary-Product estimated Descending Sorting',
            'productRequiredDelivery:asc':
                'Location summary-Product required Ascending Sorting',
            'productRequiredDelivery:desc':
                'Location summary-Product required Descending Sorting',
            'productClosedDate:asc': 'Location summary-Product completed Ascending Sorting',
            'productClosedDate:desc': 'Location summary-Product completed Descending Sorting',
            'billing:asc': 'Location summary-Billing Ascending Sorting',
            'billing:desc': 'Location summary-Billing Descending Sorting',
            'number:asc': 'Location summary-Order number Ascending Sorting',
            'number:desc': 'Location summary-Order number Descending Sorting',
            'ncp:asc': 'Location summary-Secondary reference Ascending Sorting',
            'ncp:desc': 'Location summary-Secondary reference Descending Sorting',
            'customerName:asc': 'Location summary-Customer Ascending Sorting',
            'customerName:desc': 'Location summary-Customer Descending Sorting',
            'cidn:asc': 'Location summary-Customer ID Ascending Sorting',
            'cidn:desc': 'Location summary-Customer ID Descending Sorting',
            'yourReference:asc': 'Location summary-Your Reference Ascending Sorting',
            'yourReference:desc': 'Location summary-Your Reference Descending Sorting',
            'projectManager:asc': 'Location summary-Project manager Ascending Sorting',
            'projectManager:desc': 'Location summary-Project manager Descending Sorting',
            'deliveryAddress:asc': 'Location summary-Delivery address Ascending Sorting',
            'deliveryAddress:desc': 'Location summary-Delivery address Descending Sorting',
            '': 'Location summary-Default Sorting',
            'undefined': 'Location summary-Default Sorting',
            'upcomingAppointment:asc': 'Location summary-upcoming Appointment Ascending Sorting',
            'upcomingAppointment:desc': 'Location summary-upcoming Appointment Descending Sorting',
        }
    },
    orderDetails: {
        DashboardBreadcrumb: 'Dashboard link in the breadcrumb',
        TrackingBreadcrumb: 'Tracking link in the breadcrumb',
        orderSummarySection: {
            summaryStatusFilter: {
                open: 'Details Page Order Summary Section Status filter opened',
                closed: 'Details Page Order Summary Section Status filter closed',
                applied: 'Details Page Order Summary Section Status filter applied',
                selected: 'Details Page Order Summary Section Status selected'
            },
            summaryViewBy: 'Details Page Order Summary Section View by ',
            locationAccordion: 'Details Page Order Summary Section accordion clicked',
            productSelected: 'Details Page Order Summary Section Product selected',
            toolTips: {
                orderEstimated: 'Details Page Order Summary Section Order estimated tooltip clicked'
            }
        },
        orderProgressSection: {
            orderProgressStage: {
                'Received': 'Details Page Order Progress Section Received primary stage selected',
                'Being fulfilled': 'Details Page Order Progress Section Being fulfilled primary stage selected',
                'Validation': 'Details Page Order Progress Section Validation primary stage selected',
                'Design and build': 'Details Page Order Progress Section Design and build primary stage selected',
                'Ready for use': 'Details Page Order Progress Section Ready for use primary stage selected',
                'Fulfilled': 'Details Page Order Progress Section Fulfilled primary stage selected',
                'Site visit and install':
                    'Details Page Order Progress Section Site visit and install primary stage selected',
            },
            toolTips: {
                productEstimated: 'Details Page Order Progress Section Product estimated tooltip clicked',
                productFNN: 'Details Page Order Progress Section Prodcut FNN tooltip clicked'
            },
            subStageAccordionOpen: 'Details Page Order Progress Section Substage accordion open',
            subStageAccordionClosed: 'Details Page Order Progress Section Substage accordion closed',
            hardwareDelivery: 'Details Page Order Progress Section Hardware delivery external link'
        },
        newEnquiryButton: 'Details Page New enquiry redirect to channel care support clicked',
        refreshPageButton: 'error page refresh button',
        relatedOrder: 'Related Order International',
        customerAcceptanceBanner: {
            downloadAttachment: 'Customer Acceptance Banner Test Result Attachment Downloaded',
            bannerAccept: 'Customer Acceptance banner accept button clicked',
            bannerReject: 'Customer Acceptance banner reject button clicked'
        }
    },
    productDetails: {
        details: 'Product Details link clicked',
        progresstracker: 'Progress Tracker link clicked',
        TrackConsignment: 'Track your consignment link clicked',
        OrderEnquiryOpensNewTab: 'Order enquiry (opens new tab) link clicked'
    },
    CtvViewAllOrders: 'Tracking view all orders',
    CtvViewAllLocations: 'Tracking view all locations'
});

const Components = Object.freeze({
    ordersSummaryPage: 'Tracking-Orders',
    orderDetailsPage: 'Order Details Page',
    productDetailsPage: 'Product Details Page',
    mpexDetailsPage: 'MPEX Order Details Page'
});

export {
    ApplicationName,
    Links,
    Components
};
